import { FC } from "react";

import { Box, VStack, HStack } from "@chakra-ui/react";
import { Skeleton } from "antd";
import { centsToDollars, valueOrUnknown } from "util/helpers";
import { useIdentity } from "context/auth";
import useAccountSummary from "hooks/useAccountSummary";

const ActiveListingsBids: FC = () => {
    const { accounts } = useIdentity();
    const { data, isLoading } = useAccountSummary(accounts[0]);
    const activeListings = valueOrUnknown(
        data?.activeListingsInCents,
        centsToDollars,
    );

    return (
        <>
            <HStack spacing={1}>
                <Box fontWeight="semibold" fontSize={18}>
                    Listings
                </Box>
                <Box color="#9ca3af" fontWeight="semibold">
                    - Active
                </Box>
            </HStack>
            <VStack spacing={0}>
                <HStack justifyContent="center">
                    <Box fontSize={{ base: "7cqw", md: "5cqw", lg: "3.5cqw" }}>
                        {isLoading ? <Skeleton.Input active /> : activeListings}
                    </Box>
                </HStack>
            </VStack>
            <Box justifyContent="right" display="flex" width="100%">
                <Box backgroundColor="black" px={2} py={1} borderRadius="md">
                    &nbsp;
                </Box>
            </Box>
        </>
    );
};

export default ActiveListingsBids;
